import type React from "react";
import { Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useThemeSwitcher } from "../../contexts/ThemeSwitcherContext";

const SidebarHeader: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { currentThemeInfo } = useThemeSwitcher();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pt: 0.5,
        pb: 1,
        cursor: "pointer",
        height: "70px",
      }}
      onClick={() => navigate("/trucks")}
    >
      <img
        src={currentThemeInfo.isDark ? "/logo192-dark.png" : "/logo192.png"}
        alt="ExyBox Logo"
        style={{
          height: "76px",
          width: "76px",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default SidebarHeader;
